import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import { APP_URL } from '../config';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="150%" height="150%" viewBox="0 0 1080.000000 1080.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M5135 10274 c-22 -2 -101 -9 -175 -15 -987 -81 -1989 -503 -2740
-1153 -936 -812 -1520 -1903 -1671 -3125 -26 -215 -38 -528 -28 -788 37 -985
380 -1944 981 -2738 144 -189 242 -302 416 -479 587 -596 1276 -1012 2077
-1255 197 -59 455 -118 642 -146 311 -47 347 -50 763 -49 358 0 424 3 571 22
1048 138 1944 546 2703 1233 772 697 1306 1637 1510 2660 69 344 90 570 90
959 0 337 -11 480 -55 760 -143 908 -545 1766 -1155 2460 -111 127 -397 408
-514 506 -505 423 -1052 725 -1672 924 -475 151 -896 219 -1413 225 -159 2
-308 1 -330 -1z m695 -134 c928 -81 1825 -448 2579 -1054 162 -130 443 -404
590 -576 609 -708 985 -1540 1115 -2470 29 -209 50 -596 42 -770 -4 -69 -9
-172 -12 -230 -7 -132 -47 -428 -80 -585 -144 -689 -409 -1294 -813 -1850
-585 -807 -1385 -1396 -2328 -1715 -280 -95 -580 -167 -853 -205 -63 -9 -128
-18 -145 -20 -133 -20 -675 -27 -910 -13 -254 16 -611 80 -907 164 -781 219
-1473 621 -2052 1192 -684 676 -1141 1523 -1330 2465 -50 247 -68 415 -90 842
-6 122 14 515 35 665 104 769 339 1407 746 2028 188 288 358 497 608 748 379
380 741 643 1220 889 578 296 1283 482 1925 509 132 5 533 -3 660 -14z"
          />
          <path
            d="M2940 7791 c0 -7 76 -12 223 -13 l222 -3 0 -1750 0 -1750 -222 -3
c-149 -1 -223 -6 -223 -13 0 -15 1680 -6 1810 10 111 13 310 47 360 60 68 19
275 84 290 92 8 5 50 24 93 43 148 66 360 213 441 304 19 22 54 29 72 14 5 -5
77 -37 159 -72 565 -236 793 -405 883 -653 23 -65 25 -86 26 -222 0 -125 -4
-163 -22 -228 -63 -221 -202 -380 -425 -482 -238 -109 -609 -125 -902 -40
-322 94 -604 357 -779 727 -53 112 -146 373 -146 409 0 11 -7 19 -15 19 -13 0
-15 -73 -15 -594 0 -344 4 -597 9 -600 5 -3 21 14 35 38 39 66 74 105 116 126
96 49 171 39 535 -75 165 -51 271 -79 405 -107 108 -22 448 -16 595 11 127 23
135 25 260 67 300 100 525 282 645 522 118 236 142 544 60 792 -68 205 -245
395 -530 569 -160 98 -577 291 -628 291 -15 0 -15 -2 -2 -10 13 -8 12 -12 -7
-25 -13 -9 -20 -22 -17 -30 4 -9 0 -15 -9 -15 -9 0 -18 -8 -22 -17 -8 -24 -62
-83 -76 -83 -6 0 -19 -9 -29 -20 -9 -10 -28 -24 -41 -30 -24 -11 -49 -25 -79
-45 -8 -5 -24 -11 -35 -12 -11 -2 -51 -7 -90 -12 -60 -8 -71 -7 -82 8 -11 14
-14 14 -22 1 -7 -11 -13 -12 -21 -4 -13 13 -60 6 -60 -10 -1 -6 -8 1 -16 17
-8 15 -23 27 -34 27 -10 0 -27 3 -37 6 -15 5 -15 4 -3 -5 12 -9 11 -11 -7 -11
-15 0 -21 5 -17 14 7 17 -28 38 -49 30 -8 -3 -18 0 -23 7 -5 9 -2 10 9 6 10
-3 17 -2 17 3 0 6 -4 10 -10 10 -5 0 -10 6 -10 13 0 6 -13 18 -30 25 -16 8
-30 18 -30 22 0 5 -10 20 -22 34 -38 40 -48 55 -48 66 0 6 -4 9 -9 5 -6 -3
-13 1 -18 8 -4 8 -15 17 -23 21 -8 3 -3 4 13 1 31 -6 34 0 12 21 -13 13 -16
27 -15 59 0 3 -7 19 -16 36 -19 37 -14 132 12 254 9 40 22 55 47 55 16 0 18 3
9 12 -15 15 -16 48 0 48 7 0 6 5 -3 13 -41 33 -113 150 -150 242 -21 55 -36
209 -27 282 10 79 46 186 85 252 65 112 222 233 368 283 113 39 124 39 139 10
19 -37 51 -177 70 -302 28 -189 38 -351 35 -585 l-4 -229 65 -38 c68 -39 363
-143 384 -135 11 4 17 35 46 218 15 97 12 417 -5 539 -24 168 -55 303 -98 415
-8 22 -23 61 -33 87 -10 26 -16 49 -13 52 12 12 140 -29 234 -74 148 -73 265
-175 381 -333 79 -107 187 -350 233 -524 7 -24 16 -43 21 -43 14 0 9 932 -5
937 -6 2 -21 -17 -34 -43 -36 -67 -88 -94 -183 -94 -82 0 -150 19 -270 74
-112 51 -256 102 -331 117 l-67 13 -47 80 c-244 415 -651 678 -1201 776 -230
41 -264 42 -1159 47 -602 3 -873 1 -873 -6z m1735 -26 c351 -46 598 -158 803
-364 114 -114 230 -300 287 -460 16 -47 10 -55 -50 -65 -22 -4 -53 -11 -70
-17 -169 -53 -221 -75 -330 -138 -318 -184 -502 -530 -465 -875 32 -299 137
-481 380 -657 113 -82 128 -91 153 -84 15 4 18 3 9 -3 -16 -11 4 -25 163 -107
61 -31 114 -60 119 -65 12 -11 -79 -149 -155 -234 -147 -165 -313 -270 -554
-351 -76 -26 -250 -57 -370 -66 -187 -13 -708 -12 -723 3 -9 9 -12 411 -12
1748 0 955 3 1740 7 1743 13 14 694 7 808 -8z m949 -2761 c23 -9 20 -23 -4
-17 -11 3 -20 9 -20 14 0 11 3 11 24 3z"
          />
          <path
            d="M5680 5009 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"
          />
        </g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>; // Render logo without any link
  }

  // Render as external link
  return (
    <a
      href={APP_URL}
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: 'block', width: '100%', height: '100%' }}
    >
      {logo}
    </a>
  );
}
